import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { SobDemandaLabelComponent } from './sob-demanda-label.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        SobDemandaLabelComponent
    ],
    exports: [
        SobDemandaLabelComponent
    ]
})
export class SobDemandaLabelModule { }
